module.exports = __webpack_public_path__ + "img/9788990492784.f53420b4.jpg";